import Constants from "@husky-hrc/Utilities/Constants";
import { addToEndOfChain, Handler } from "@insite/client-framework/HandlerCreator";
import { chain } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

type HandlerType = Handler;

export const DispatchResetPlaceOrderParameter: HandlerType = props => {
    props.dispatch({
        type: Constants.Actions.ResetPlaceOrderParameter,
    } as any);
};

addToEndOfChain(chain, DispatchResetPlaceOrderParameter);
